import { render } from "./Navbar.vue?vue&type=template&id=22a85c64"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__